import React from 'react';
import ReactModal from 'react-modal';

const CustomModal = (props) => {

    return (
        <ReactModal 
        closeTimeoutMS={300}
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
        className = "modal__content"
        overlayClassName = "modal__overlay"
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        >
            {props.children}
        </ReactModal>
    );
}

export default CustomModal;